import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import seo from "../seo/pages.json";

// Keeps the document head in step with the current route. The deployed HTML for each page already carries these
// values (stamped by scripts/seo-pages.js); this covers the dev server and routes that fall back to index.html,
// such as the private dashboard pages, which must not be indexed.
const pagesByPath = Object.fromEntries(seo.pages.map(page => [page.path, page]));

function setHeadElement(selector, tagName, attributes) {
    let element = document.head.querySelector(selector);
    if (!attributes) {
        if (element) element.remove();
        return;
    }
    if (!element) {
        element = document.createElement(tagName);
        document.head.appendChild(element);
    }
    Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
}

function PageMeta() {
    const {pathname} = useLocation();

    useEffect(() => {
        const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
        const page = pagesByPath[path];
        const noindex = page
            ? Boolean(page.noindex)
            : seo.noindexPrefixes.some(prefix => path === prefix || path.startsWith(prefix + "/"));

        document.title = page ? page.title : seo.site.name;
        setHeadElement('meta[name="description"]', "meta",
            {name: "description", content: (page && page.description) || seo.site.description});
        setHeadElement('link[rel="canonical"]', "link",
            page && !noindex ? {rel: "canonical", href: seo.site.url + (path === "/" ? "/" : path)} : null);
        setHeadElement('meta[name="robots"]', "meta", noindex ? {name: "robots", content: "noindex"} : null);
    }, [pathname]);

    return null;
}

export default PageMeta;
